module.exports = new __parcel__URL__("quick_summary_spotlight.2a439c01.gif").toString();